import { faCaretLeft, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "antd";
import mergeClassNames from "common/mergeClassNames";
import React from "react";
import CypressTestIds from "../../../cypress/CypressTestIds";

interface ISlideoutGroupedButtonsProps {
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    hoverClassName?: string;
    hoverStyle?: React.CSSProperties;
}

export default function SlideoutMenu({ children, className, style, hoverClassName, hoverStyle }: ISlideoutGroupedButtonsProps) {
    const [hovered, setHovered] = React.useState<boolean>(false);

    return (
        <div data-testid={CypressTestIds.COMPONENT_ATOM_SLIDEOUTMENU} className={mergeClassNames("relative z-50 block size-[32px] overflow-visible", className)} style={style}>
            <div
                className={mergeClassNames(
                    "group absolute left-0 top-0 z-50 flex w-[32px] flex-row flex-nowrap items-center justify-start gap-2 overflow-hidden rounded-md pr-4 transition-all duration-150 hover:w-max hover:bg-slate-50 hover:shadow-md",
                    hoverClassName,
                )}
                style={hovered ? hoverStyle : undefined}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <Button type="text" className="hidden w-[32px] flex-none group-hover:block" icon={<FontAwesomeIcon icon={faCaretLeft} />} onClick={(e) => e.stopPropagation()} />
                <Button
                    type="text"
                    className="block w-[32px] flex-none group-hover:hidden"
                    icon={<FontAwesomeIcon icon={faEllipsisVertical} />}
                    onClick={(e) => e.stopPropagation()}
                />
                {children}
            </div>
        </div>
    );
}
